import styled from 'styled-components'

export const NavbarItem = styled.div`
  margin: 0 8px;

  /* Adjust margin right to the penultimate child
  as the last one will always be the right sidebar header */
  &:nth-last-child(2) {
    margin-right: 8px;
  }
`

export const NavbarBackButtonItem = styled(NavbarItem)`
  margin: 0 8px 0 0;
  line-height: 1;
`

export const AddAnnotationText = styled(NavbarItem)`
  font-size: 0.8125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
`

export const MiddleContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`
